import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import UiImage from './Image';
import Link from './Link';
import Caption from '../Caption';

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: this.props.selectedImage,
      currentImage: 0
    };
    this.interval = null;
  }
  componentDidMount() {
    if (this.props.autostart)
      this.interval = setInterval(() => this.slideShow(), 5000);
    // preload
    this.props.images.forEach(image => {
      const img = new Image();
      img.src = this.props.getImage(image);
    });
  }
  componentWillUnmount() {
    this.clear();
  }
  clear() {
    if (this.interval) clearInterval(this.interval);
  }
  slideShow() {
    const { images } = this.props;
    let nextImg = this.state.currentImage + 1;
    if (nextImg > images.length - 1) nextImg = 0;
    this.openImage(images[nextImg], nextImg);
  }
  nextImage() {
    this.slideShow();
    this.clear();
  }
  prevImage() {
    const { images } = this.props;
    let nextImg = this.state.currentImage - 1;
    if (nextImg < 0) nextImg = images.length - 1;
    this.clear();
    this.openImage(images[nextImg], nextImg);
  }
  openImage(img, nextImage) {
    let obj = { image: img };
    if (nextImage !== undefined) obj.currentImage = nextImage;
    this.setState(obj);
  }
  getCaption() {
    return this.props.parent.images.find(
      img => img.folder === this.state.image.folder
    );
  }
  render() {
    const { images } = this.props;
    return (
      <ul className="list list-bigger">
        <li className="row row--small">
          <Link
            text="previous"
            className="text-italic"
            // disabled={this.state.currentImage === 0}
            onClick={this.prevImage.bind(this)}
          />
          <div>|</div>
          <Link
            text="next"
            className="text-italic"
            // disabled={this.state.currentImage === images.length - 1}
            onClick={this.nextImage.bind(this)}
          />
          <div>|</div>
          <Link
            text="stop"
            className="text-italic"
            // disabled={this.state.currentImage === images.length - 1}
            onClick={this.clear.bind(this)}
          />
        </li>
        <li className="box-medium box-hidden box-border pos-rel">
          <TransitionGroup>
            <CSSTransition
              key={this.state.currentImage}
              classNames="fade"
              timeout={1000}
            >
              <UiImage
                type="img-bg"
                id="image"
                src={this.props.getImage(this.state.image)}
                srcLarge={
                  this.state.image.large
                    ? this.props.getImage(this.state.image, true)
                    : ''
                }
                size={this.state.image.size}
                className="pos-abs"
                containerClassName="box-medium pos-abs"
              />
            </CSSTransition>
          </TransitionGroup>
        </li>
        {this.state.image && (
          <li className="margin-top--huge">
            <Caption {...this.getCaption()} />
          </li>
        )}
        {this.props.showTiles && (
          <li>
            <ul className="container-mini list">
              <li className="row row--nowrap row--mini">
                {images.map((image, i) => (
                  <div className="col-1 cols-2--s" key={i}>
                    <UiImage
                      onClick={() => this.openImage(image)}
                      selected={this.state.image === image}
                      type="img-bg"
                      src={this.props.getImage(image)}
                      className="box-full img-hover"
                    />
                  </div>
                ))}
              </li>
            </ul>
          </li>
        )}
      </ul>
    );
  }
}

Slider.defaultProps = { autostart: false, showTiles: false };

Slider.propTypes = {
  images: PropTypes.array.isRequired,
  selectedImage: PropTypes.shape({}).isRequired,
  getImage: PropTypes.func.isRequired,
  autostart: PropTypes.bool,
  showTiles: PropTypes.bool,
  parent: PropTypes.shape({})
};

export default Slider;



// WEBPACK FOOTER //
// ./src/components/ui/Slider.jsx